import TableHeader from "../../../../../components/Table/TableHeader";
import TableCell from "../../../../../components/Table/TableCell";
import React from "react";
import Table from "../../../../../components/Table/Table";
import TableContainer from "../../../../../components/Table/TableContainer";
import CerfTable from "../Variables/CerfTable";
import TableRow from "../../../../../components/Table/TableRow";


export default function TableCERF({className, ...props}) {
    const table = CerfTable;

    function getNumberOfRows() {
        let rows = 0;
        Object.keys(table).map((key, index) => {
            if (table[key].length > rows) {
                rows = table[key].length;
            }
        })
        return rows;
    }

    return (
        <div className={`overflow-auto ${className}`}>
            <div
                className={` max-w-[80vw] bg-transparent border-none overflow-auto rounded-lg dark:bg-darkTheme-800 border-[1px]  `}>
                <div className={` max-w-[80vw] bg-transparent border-none  whitespace-nowrap  overflow-x-auto `}>
                    <Table className={""}>
                        <thead className={` ${className} text-xs `}>
                        <tr>
                            {
                                Object.keys(table).map((key, index) => {
                                    return (
                                        <td  key={index} className={`p-3 lg:p-6 border-b-[1px] border-r-[1px] last:border-r-[0px] whitespace-no-wrap `}>
                                            <p className={`text-base lg:text-xl text-center uppercase font-bold text-black`}>
                                                {
                                                    key
                                                }
                                            </p>
                                        </td>)
                                })
                            }

                        </tr>
                        </thead>
                        <tbody className={` w-full ${className}  `}>
                        {
                            new Array(getNumberOfRows()).fill(0).map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        {
                                            Object.keys(table).map((key, index2) => {
                                                return (
                                                    <td key={index2} className={`p-3 lg:p-6 border-b-[1px] border-r-[1px] last:border-r-[0px] whitespace-no-wrap `}>
                                                        <div className={`text-center `}>
                                                            {
                                                                typeof table[key][index] === typeof [] ? (
                                                                    <ul  className={`list-disc ml-8 text-start list-inside`}>
                                                                        {
                                                                            table[key][index].map((item, index3) => {
                                                                                    return (
                                                                                        <li key={index3}>
                                                                                            {item}
                                                                                        </li>
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    </ul>
                                                                ) : table[key][index]
                                                            }
                                                        </div>
                                                    </td>
                                                )
                                            })
                                        }

                                    </TableRow>
                                )
                            })

                        }
                        </tbody>

                    </Table>

                </div>
            </div>
        </div>

    )
}